import { PageBankAccountsAccountActivity } from './AccountActivity';
import { PageBankAccountsACHPositivePay } from './ACHPositivePay';
import { PageBankAccountsDocuments } from './Documents';
import { PageBankAccountsEdit } from './Edit';
import { PageBankAccountsInterestPayoutView } from './InterestPayout/View';
import { PageBankAccounts } from './Overview';
import { PageBankAccountsPaymentAddresses } from './PaymentAddresses';
import { PageBankAccountsStatementsRedirect } from './Redirect';
import { PageBankAccountSection } from './Section';
import { PageBankAccountsTransfers } from './Transfers';

export const BANK_ACCOUNTS = {
  BankAccounts: PageBankAccounts,
  BankAccountSection: PageBankAccountSection,
  BankAccountsACHPositivePay: PageBankAccountsACHPositivePay,
  BankAccountsEdit: PageBankAccountsEdit,
  BankAccountsTransfers: PageBankAccountsTransfers,
  BankAccountsAccountActivity: PageBankAccountsAccountActivity,
  BankAccountsPaymentAddresses: PageBankAccountsPaymentAddresses,
  BankAccountsDocuments: PageBankAccountsDocuments,
  BankAccountsStatementsRedirect: PageBankAccountsStatementsRedirect,
  BankAccountsInterestPayoutView: PageBankAccountsInterestPayoutView,
} as const;
